// sentry.client.config.ts
import { useRuntimeConfig } from '#app' // Nuxt 3 composable
import * as Sentry from '@sentry/nuxt'

const {
  public: {
    sentryDsn,
  },
} = useRuntimeConfig()

Sentry.init({
  dsn: sentryDsn as string,
})
